// extracted by mini-css-extract-plugin
export default {"spinner":"ShowSpinner_spinner__OaOo6"};